<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-50 homo-btn">
      <toggle-buttons :btnList="homogeneityList" :label="$t('localization.homogeneity')" @btnValue="getHomogeneity" :editTB="$store.state.plot.localization.homogeneity" />
    </div>
    <div class="md-layout-item md-size-50 homo-btn">
      <toggle-buttons :btnList="managIntensityList" :label="$t('localization.managIntensity')" @btnValue="getManagIntensity" :editTB="$store.state.plot.localization.manag_intensity" />
    </div>

    <!-- Development Stage -->
    <div class="md-layout-item md-size-100">
      <label class="label-fs">{{ $t("localization.developmentStage") }}</label>
      <development-stage></development-stage>
    </div>

    <!-- Origin -->
    <div class="md-layout-item md-size-100">
      <label class="label-fs">{{ $t("localization.origin") }}</label>
      <origin></origin>
    </div>

    <!-- Regeneration -->
    <div class="md-layout-item md-size-100">
      <label class="label-fs">{{ $t("localization.regeneration") }}</label>
      <regeneration :edit="edit"></regeneration>
    </div>
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import Origin from '@/components/descParc/Origin'
import Regeneration from '@/components/descParc/Regeneration'
import DevelopmentStage from '@/components/descParc/DevelopmentStage'

import { getDomain } from '@/assets/scripts/domainsManager'

const HOMOGENEITY = 'homogeneity'
const MANAG_INTENSITY = 'manag_intensity'

export default {
  name: 'ForestStand',
  props: ['edit'],
  components: {
    ToggleButtons,
    Origin,
    Regeneration,
    DevelopmentStage
  },
  data: () => ({
    homogeneityList: {},
    managIntensityList: {}
  }),
  mounted () {
    getDomain(HOMOGENEITY).then(data => {
      this.homogeneityList = data[this.$i18n.locale]
    })
    getDomain(MANAG_INTENSITY).then(data => {
      this.managIntensityList = data[this.$i18n.locale]
    })
  },
  methods: {
    getHomogeneity: function (homogeneity) {
      this.$store.state.plot.localization.homogeneity = homogeneity
    },

    getManagIntensity: function (managIntensity) {
      this.$store.state.plot.localization.manag_intensity = managIntensity
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .homo-btn {
    margin-top: -20px;
  }

  .label-fs {
    font-weight: bold;
  }
</style>
